import React from "react";

/**
 * Top-level error boundary. Catches render crashes and shows a recovery UI
 * instead of a blank screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[DPL Jade] Render error:", error, info);
  }

  handleReset = () => {
    // Clear persisted state so a corrupt save can't block the app forever
    try {
      const key = localStorage.getItem("dpl-jade:current-project-id");
      if (key) localStorage.removeItem(`dpl-jade:${key}`);
    } catch {}
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        width: "100vw", height: "100vh", background: "#07090f",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'JetBrains Mono',monospace", color: "#8496a8",
      }}>
        <div style={{ maxWidth: 440, padding: 32, textAlign: "center" }}>
          <div style={{ fontSize: 28, marginBottom: 16 }}>⚠</div>
          <div style={{ fontSize: 13, color: "#f87171", fontWeight: 700, marginBottom: 10 }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 9, color: "#3d5068", marginBottom: 8, lineHeight: 1.8 }}>
            {this.state.error?.message || "Unknown render error"}
          </div>
          <div style={{ fontSize: 8, color: "#1e2a3a", marginBottom: 24, lineHeight: 1.8 }}>
            If this keeps happening, clearing local state may help.
          </div>
          <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
            <button
              onClick={this.handleReset}
              style={{ padding: "8px 18px", background: "#0c1828", border: "1px solid #3b82f640", color: "#3b82f6", borderRadius: 5, cursor: "pointer", fontSize: 10, fontFamily: "inherit", fontWeight: 700 }}
            >
              ↺ Reset &amp; reload
            </button>
          </div>
        </div>
      </div>
    );
  }
}
